import { ProjectGroupRoleDto } from "./projectgrouprole";

export class SquirrelSessionRequest {
    languageKey!: string;
    projectGuid!: string;
    projectUrl!:string;
    projectUserGroups: ProjectUserGroup[] = [];
    projectPermissions:string[] = [];
}

export class SquirrelSessionResponse {
    languageKey!: string;
    projectGuid!: string;
    projectUserGroups: ProjectUserGroup[] = [];
    legacySquirrelUrl!:string;
}

export class ProjectUserGroup {
    id!: string;
    groupRoleId!: string;
}


export class ProjectSessionRequest {
    projectGuid!:string;
    projectName!:string;
    projectUrl!:string;
    languageKey!:string;
    projectUserGroups:ProjectGroupRoleDto[] = [];

}